// Small sound helper — plays short move / capture / correct / wrong cues.
// Uses Lichess standard sound assets bundled under /public/sounds.
// Silently no-ops if audio isn't available (e.g., before user gesture).

const CACHE = {};

function get(name) {
  if (!CACHE[name]) {
    const a = new Audio(`/sounds/${name}.mp3`);
    a.volume = 0.55;
    CACHE[name] = a;
  }
  return CACHE[name];
}

export function playSound(name) {
  try {
    const a = get(name);
    a.currentTime = 0;
    const p = a.play();
    if (p && p.catch) p.catch(() => {});
  } catch {
    /* ignore */
  }
}

export const Sounds = {
  move: () => playSound("Move"),
  capture: () => playSound("Capture"),
  correct: () => playSound("GenericNotify"),
  wrong: () => playSound("Error"),
};
